import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITradeFair } from '@sv/interfaces';
import { BehaviorSubject } from 'rxjs';
import { customApp } from 'src/app/_configuration/configuration';

@Injectable({
  providedIn: 'root',
})
export class TradefairService {
  // Initial TradefairComponent. If this is loaded by accident the tradefair component will abort the loading process
  notLoaded: ITradeFair = {
    settings: {
      name: '',
      availableTags: [],
      overline: '',
      headline: '',
      text: '',
      personalizedAnalytics: false,
      searchText: '',
    },
    booths: [],
    owners: [],
  };

  fairListener = new BehaviorSubject<ITradeFair>(this.notLoaded);

  constructor(private http: HttpClient) {}

  getFairListener() {
    return this.fairListener.asObservable();
  }

  async setFair(fairId: string | ITradeFair) {
    if (typeof fairId === 'string') {
      try {
        const tradeFair = await this.getTradeFairWithBooths(fairId);
        this.fairListener.next(tradeFair);
      } catch (error) {
        console.log(error);
        // TODO wie am besten handelen
      }
    }
    else {
      this.fairListener.next(fairId);
    }
  }

  async getTradeFairById(tradeFairId: string): Promise<ITradeFair> {
    const result = await this.http
      .get<{ status: string; data: ITradeFair; error? }>(customApp.url + `/app/event/tradeFair/findById?id=${tradeFairId}`)
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      return result.data;
    }
  }
  async getTradeFairWithBooths(tradeFairId: string): Promise<ITradeFair> {
    const result = await this.http
      .get<{ status: string; data: ITradeFair; error? }>(customApp.url + `/app/event/tradeFair/allBooths?id=${tradeFairId}`)
      .toPromise();

    if (result.status === 'error') {
      throw result.error;
    } else {
      return result.data;
    }
  }
}
